/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SourcingSearchMatchingSkillOrigin } from './';
import {
    SourcingSearchMatchingSkillOriginFromJSON,
    SourcingSearchMatchingSkillOriginFromJSONTyped,
    SourcingSearchMatchingSkillOriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface SourcingSearchMatchingSkill
 */
export interface SourcingSearchMatchingSkill {
    /**
     * 
     * @type {string}
     * @memberof SourcingSearchMatchingSkill
     */
    label: string;
    /**
     * 
     * @type {SourcingSearchMatchingSkillOrigin}
     * @memberof SourcingSearchMatchingSkill
     */
    origin?: SourcingSearchMatchingSkillOrigin;
}

/**
 * Check if a given object implements the SourcingSearchMatchingSkill interface.
 */
export function instanceOfSourcingSearchMatchingSkill(value: object): value is SourcingSearchMatchingSkill {
    if (!('label' in value) || value['label'] === undefined) return false;
    return true;
}

export function SourcingSearchMatchingSkillFromJSON(json: any): SourcingSearchMatchingSkill {
    return SourcingSearchMatchingSkillFromJSONTyped(json, false);
}

export function SourcingSearchMatchingSkillFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchMatchingSkill {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'origin': json['origin'] == null ? undefined : SourcingSearchMatchingSkillOriginFromJSON(json['origin']),
    };
}

export function SourcingSearchMatchingSkillToJSON(value?: SourcingSearchMatchingSkill | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'origin': SourcingSearchMatchingSkillOriginToJSON(value['origin']),
    };
}

